import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import FooterComponent from "../components/FooterComponent";
import { useTranslation } from 'react-i18next';
import Policy from "../components/Policy";

const PolicyView = () => {
    const { t } = useTranslation();

    const {hash, key} = useLocation();

    useEffect(() => {
        if (hash) {
            const targetElement = document.getElementById(hash.substring(1));
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [key, hash]);

    return (
        <div>
            <Policy />
            <FooterComponent />
        </div>
    )
}

export default PolicyView;